<template>
    <div class="datatable-row-actions">
        <Button
            v-for="action in visibleActions"
            :key="action.slug"
            :href="action.kind === 'link' ? routeFor(action) : null"
            :dusk="action.dusk ?? `grid-${action.slug}`"
            :color="action.color ?? 'default'"
            size="sm"
            variant="inline"
            @click="action.kind === 'link' ? undefined : run(action)"
        >
            {{ lang(action.label) }}
        </Button>
    </div>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue';
import Button from '@src/Common/Components/Button.vue';
import { lang } from '@/lang/composable';
import type { RowAction, RowActionHandler } from '../types';

const props = defineProps<{
    entry: Record<string, any>;
}>();

const actions = inject<RowAction[]>('datagrid:rowActions', []);
const handler = inject<RowActionHandler | null>('datagrid:onRowAction', null);

/**
 * Actions the server resolved as available for this row. A row without the
 * map (a grid still on the legacy path) shows nothing rather than guessing.
 */
const visibleActions = computed((): RowAction[] => {
    const resolved = props.entry?._actions ?? {};

    return actions.filter((action) => resolved[action.slug] === true);
});

const routeFor = (action: RowAction): string => route(action.route, { id: props.entry.id });

const run = (action: RowAction): void => {
    if (handler) {
        handler(action, props.entry);
    }
};
</script>
